export default {
  configurationHead: {
    title: '設定',
  },
};
